import { FC } from "react"
import { IInput } from "./Input"

const RadioControls: FC<IInput> = ({
  className,
  label,
  inputIdentifier,
  name,
  checked,
  value,
  onChange,
  disabled
}) => {
  return (
    <label
      className={`
      ${className && className} 
      ${checked && "checked"} ${disabled && "disabled"}
      ${inputIdentifier}-btn
     ocs-radio-container`}
      htmlFor={inputIdentifier}
    >
      <input
        type="radio"
        onChange={onChange}
        value={value}
        name={name}
        checked={checked}
        id={inputIdentifier}
        disabled={disabled}
      />
      <span className="ocs-radio-check" />
      {label}
    </label>
  )
}

export default RadioControls
